var map = {
	"./arrow-forward.svg": 3041,
	"./attachment.svg": 6612,
	"./cash_in_circle_icon.svg": 7508,
	"./icon-small.svg": 7436,
	"./play-button-downloaded2.svg": 5794,
	"./playButton.svg": 208,
	"./playButtonDownloaded.svg": 7650,
	"./search_icon_in_circle.svg": 3089,
	"./sec_icon.svg": 5974,
	"./send-icon.svg": 6419,
	"./stock_going_up_icon.svg": 4836,
	"./user_avatar_in_circle.svg": 1241,
	"./whatsapp_icon.svg": 7771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8107;